// frontend/src/components/GuideWelcome.jsx
import React from "react";
import "./GuideWelcome.css";
import aiGuide from "../assets/ai-guide.webp"; // ← bundlas korrekt till /static/media/...

export default function GuideWelcome() {
  return (
    <section className="guide-welcome-card">
      <img
        src={aiGuide}
        alt="Your local AI travel assistant"
        className="guide-avatar"
        width={160}
        height={160}
        loading="eager"
        fetchPriority="high"
      />
      <div className="guide-text">
        <h2>👋 Your Arctic AI Guide</h2>
        <p>Discover the best tours and hidden gems in Kiruna & Abisko.</p>
        <p>Ask anything – available 24/7 in your language.</p>
        <div className="guide-icons">
          <span>❄️ Tours</span>
          <span>🌌 Northern Lights</span>
          <span>🧭 Local tips</span>
        </div>
      </div>
    </section>
  );
}
